import { AdsPlacement } from 'types/enums/AdsPlacement';

import { getSessionStorageItem, setSessionStorageItem } from './sessionStorage';

const SESSION_ADS_STORAGE_KEY = 'session_ads_shown';

export const getSessionAdsListShown = (): AdsPlacement[] => {
  const data = getSessionStorageItem(SESSION_ADS_STORAGE_KEY);

  return data ? JSON.parse(data) : [];
};

export const setSessionAdsItemShown = (adsPlacement: AdsPlacement) => {
  const shownAds = getSessionAdsListShown();

  setSessionStorageItem(
    SESSION_ADS_STORAGE_KEY,
    JSON.stringify(shownAds.concat([adsPlacement]))
  );
};

export const getIsSessionAdsItemShown = (adsPlacement: AdsPlacement) => {
  const shownAds = getSessionAdsListShown();

  return shownAds.includes(adsPlacement);
};
